import React from 'react';
import '../../styles/especialidades.css';
import LivroCard from '../livros/LivroCard';

import livro1 from '../../img/livros/Livro1.jpg';
import livro2 from '../../img/livros/Livro2.jpg';
import livro3 from '../../img/livros/Livro3.jpg';
import livro4 from '../../img/livros/Livro4.jpg';
import livro5 from '../../img/livros/Livro5.jpg';

const AlemDaClinica: React.FC = () => {
  return (
    <>
    <h2 className="livros_publicados" id="livros_publicados">Livros Publicados</h2>
      <section className="container-livros">

        <LivroCard
          titulo="A prática psicopedagógica"
          descricao="Esta obra explora a atuação da Psicopedagogia em diversos cenários, desde o trabalho com crianças até adultos, idosos e universitários. Aborda temas como mediação de conflitos, vínculos na aprendizagem, parentalidade tardia e inclusão escolar. Também destaca a prática psicopedagógica em instituições de saúde, universidades e escolas, com ênfase na aprendizagem da Matemática e na formação de profissionais da área."
          imagem={livro1}
          linkCompra="https://www.amazon.com.br/Pr%C3%A1tica-Psicopedag%C3%B3gica-Gilca-Lucena-Kortmann/dp/8578543459"
        />

        <LivroCard
          titulo="A Psicopedagoria entre conhecimentos e saberes"
          descricao="O livro destaca as habilidades essenciais do psicopedagogo, como escuta sensível, empatia e domínio teórico. Enfatiza a importância de compreender a aprendizagem de forma ampla, considerando os vínculos entre sujeito, família e escola. A obra reforça que todos têm potencial para aprender, desde que sejam respeitadas suas singularidades e contextos."
          imagem={livro2}
          invertido={true}
          linkCompra="https://www.amazon.com.br/Psicopedagogia-Entre-Conhecimentos-Saberes/dp/8578543785"
        />

        <LivroCard
          titulo="Psicopedagogia e Subjetividade no Diálogo com a Escola - Ciência, Amor e Poesia "
          descricao="A obra apresenta contribuições do grupo “Ações Cooperativas” que atua em diversos estados brasileiros, explorando o ensino e aprendizagem sob uma perspectiva subjetiva e humanizadora. Valoriza a dimensão afetiva do processo educativo e evidencia a importância das relações entre educadores e alunos. Indicado a professores, gestores, psicopedagogos, psicólogos e profissionais da educação, também é referência para cursos de formação continuada, pós-graduação e áreas afins."
          imagem={livro3}
          linkCompra="https://www.amazon.com.br/Psicopedagogia-Subjetividade-Di%C3%A1logo-com-Escola/dp/857854708X"
        />

        <LivroCard
          titulo="História da Psicopedagogia e da Abpp no Brasil – Fatos, protagonistas e conquistas"
          descricao="Este livro reúne relatos de profissionais que vivenciaram a construção da Psicopedagogia no Brasil, documentando suas principais conquistas e desafios. A obra oferece uma visão fidedigna do processo de consolidação da área, destacando sua legitimidade social mesmo sem regulamentação legal. É um importante registro histórico e institucional para estudantes, profissionais e interessados na evolução da Psicopedagogia no país."
          imagem={livro4}
          invertido={true}
          linkCompra="https://www.amazon.com.br/Hist%C3%B3ria-Supervis%C3%A3o-Educacional-no-Brasil/dp/8588081849"
        />

        <LivroCard
          titulo="Família e Aprendizagem - Uma Relação Necessária"
          descricao="A obra analisa a relação entre família e aprendizagem a partir de uma abordagem transdisciplinar, unindo educação e saúde. Os capítulos exploram como diferentes configurações familiares influenciam o processo de aprender, destacando possíveis obstáculos ao longo da trajetória pessoal e acadêmica do sujeito. Ideal para psicopedagogos clínicos, educadores e profissionais que atuam na interface entre família, educação e desenvolvimento."
          imagem={livro5}
          linkCompra="https://www.amazon.com.br/Fam%C3%ADlia-Aprendizagem-Fabiani-Ortiz/dp/8588081512"
        />

        {/* Adicione mais livros seguindo o padrão */}
      </section>
    </>
  );
};

export default AlemDaClinica;
